import { useEffect, useState } from 'react';

import { useAppDispatch } from '@store/hooks/useAppDispatch';
import { partsSearch } from '@reducers/search';
import {
  GlobalSearchItem,
  OperationSearchItem,
  PartSearchItem,
  RecipeOperationSearchItem,
} from '../../../../interfaces/search';

export interface UseManageOperationsBlockParams {
  existingPart?: GlobalSearchItem | null;
  partId?: number;
}

export const useManageOperationsBlock = <TItem extends OperationSearchItem | RecipeOperationSearchItem>({
  existingPart,
  partId,
}: UseManageOperationsBlockParams) => {
  const dispatch = useAppDispatch();

  const [part, setPart] = useState<PartSearchItem | undefined>();
  const [operations, setOperations] = useState<TItem[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (partId == null || existingPart) {
      return;
    }

    (async () => {
      setIsLoading(true);
      const resParts = await dispatch(
        partsSearch({
          data: {
            search: '',
            top: 100,
            skip: 0,
          },
          filter: { oDataFilter: `PartId eq ${partId}` },
          select: null,
          resetHistory: true,
          ignoreHistory: true,
        })
      );

      if (resParts?.searchResult) {
        setPart(resParts.searchResult[0]);
      } else {
        setIsError(true);
      }
      setIsLoading(false);
    })();
  }, [partId, existingPart, dispatch]);

  return {
    part,
    operations,
    setOperations,
    isError,
    setIsError,
    isLoading,
    setIsLoading,
  };
};
